import React from 'react';

import CardDialog from '../../../CardDialog';
import InnerTabs from '../../../core/Layout/InnerTabs/InnerTabs';

import { WorkflowExecutionsTab } from './WorkflowExecutionsTab';
import WorkflowRulesTab from './WorkflowRulesTab';

const WorkflowEngine: React.FC = () => {
  const tabs = [
    { label: 'Rules', url: 'rules', component: WorkflowRulesTab },
    { label: 'Executions', url: 'executions', component: WorkflowExecutionsTab },
  ];

  return (
    <CardDialog noCardTitle>
      <InnerTabs tabs={tabs} />
    </CardDialog>
  );
};

export default WorkflowEngine;
